export default __webpack_public_path__ + "static/media/tdsa_logo_2.9d8df2ac.svg";